import { useQuery } from '@tanstack/react-query';

import { adManagerGetJob } from './api';

export function useADManagerEnabled(jobId: number) {
  const query = useQuery({
    queryKey: ['ad-manager-job', jobId],
    queryFn: () => adManagerGetJob(jobId.toString()),
  });

  return query.isSuccess && query.data.templateName !== null;
}
